// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19Z3x","icon":"styles_icon__amhls"};